export default "__VITE_ASSET__4ece3804__"